import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { SERVICES } from "@/data/site";
import { GlowOrb } from "@/components/common/GlowOrb";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/seo/Seo";

export default function Services() {
  return (
    <div className="relative" data-testid="services-page">
      <Seo
        title="Services"
        description="AI, AI agent, custom software, SaaS, CRM, mobile app, web application, EdTech, MVP and software modernisation services engineered end-to-end by CloudLab."
        keywords="AI services, AI agent development, custom software development, SaaS development, CRM development, mobile app development, web application development, EdTech development, MVP development, software modernisation"
      />
      <section className="relative py-20 md:py-28 overflow-hidden">
        <GlowOrb className="top-0 right-0" color="primary" size={500} />
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-primary mb-4">Services</div>
          <h1 className="font-heading font-black tracking-tighter text-5xl md:text-6xl lg:text-7xl max-w-4xl leading-[0.95]">
            Ten capabilities. <span className="text-gradient-aurora">Delivered end-to-end.</span>
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-muted-foreground leading-relaxed">
            From AI process automation to enterprise SaaS — we design, engineer and operate the systems that put your business a decade ahead.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <Link
                to={`/services/${s.slug}`}
                key={s.slug}
                className="group glass rounded-3xl p-6 hover:-translate-y-1 hover:border-primary/50 transition-[transform,border-color] duration-300"
                data-testid={`services-page-card-${s.slug}`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
                    <Icon className="w-5 h-5" />
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-muted-foreground group-hover:text-primary" />
                </div>
                <h3 className="mt-6 font-heading font-bold text-xl">{s.name}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{s.tagline}</p>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
